/**
 * Extrai metadados estruturados e ricos de um elemento HTML clicado para registrar na timeline.
 */
export function getElementMetadata(el: HTMLElement) {
  try {
    const tagName = el.tagName;
    const id = el.id || null;
    
    // SVG className check (SVGAnimatedString)
    const className = typeof el.className === 'string' 
      ? el.className 
      : (el.getAttribute('class') || null);
      
    const role = el.getAttribute('role') || null;
    const type = el.getAttribute('type') || null;
    const name = el.getAttribute('name') || null;
    const placeholder = el.getAttribute('placeholder') || null;
    const ariaLabel = el.getAttribute('aria-label') || el.getAttribute('aria-labelledby') || null;
    const title = el.getAttribute('title') || null;
    const href = el.getAttribute('href') || null;
    
    let value = null;
    const isInput = tagName === 'INPUT' || tagName === 'SELECT' || tagName === 'TEXTAREA';
    if (isInput) {
      value = (el as any).value || null;
    }
    
    const text = (el.innerText || el.textContent || '').trim().substring(0, 100);
    
    let associatedLabel = null;
    if (id && typeof el.ownerDocument?.querySelector === 'function') {
      try {
        const escapedId = id.replace(/["\\]/g, '\\$&');
        const labelEl = el.ownerDocument.querySelector(`label[for="${escapedId}"]`);
        if (labelEl) {
          associatedLabel = labelEl.textContent?.trim() || null;
        }
      } catch {
        // ignore selector issues
      }
    }
    
    if (!associatedLabel && typeof el.closest === 'function') {
      try {
        const labelAncestor = el.closest('label');
        if (labelAncestor) {
          associatedLabel = labelAncestor.textContent?.trim() || null;
        } else {
          const parent = el.parentElement;
          if (parent) {
            const textNodes = Array.from(parent.childNodes)
              .filter(n => n.nodeType === 3)
              .map(n => n.textContent?.trim())
              .filter(Boolean);
            if (textNodes.length > 0) {
              associatedLabel = textNodes.join(' ') || null;
            }
          }
        }
      } catch {
        // ignore
      }
    }
    
    let cardTitle = null;
    if (typeof el.closest === 'function') {
      try {
        const cardAncestor = el.closest('.card, [class*="card"], .ac-card, [class*="panel"]');
        if (cardAncestor) {
          const headerEl = cardAncestor.querySelector('h1, h2, h3, h4, h5, .card-title, [class*="title"], [class*="header"]');
          if (headerEl) {
            cardTitle = headerEl.textContent?.trim().substring(0, 50) || null;
          }
        }
      } catch {
        // ignore
      }
    }
    
    let formTitle = null;
    if (typeof el.closest === 'function') {
      try {
        const formAncestor = el.closest('form, [class*="form"]');
        if (formAncestor) {
          const headerEl = formAncestor.querySelector('h1, h2, h3, h4, h5, legend, [class*="title"], [class*="header"]');
          if (headerEl) {
            formTitle = headerEl.textContent?.trim().substring(0, 50) || null;
          }
        }
      } catch {
        // ignore
      }
    }
    
    return {
      tagName,
      id,
      className,
      role,
      type,
      name,
      placeholder,
      ariaLabel,
      title,
      href,
      value,
      text,
      associatedLabel,
      cardTitle,
      formTitle
    };
  } catch (err) {
    return { error: String(err) };
  }
}
